import React, { useEffect, useState } from 'react'
import { createAppReleaseCheck, documentRelease } from '../lib/appRelease.js'
import { useTranslation } from '../i18n/LanguageContext'
import './AppUpdateNotice.css'

export default function AppUpdateNotice() {
  const { t } = useTranslation()
  const [release, setRelease] = useState(null)
  const [dismissed, setDismissed] = useState(null)
  const [reviewing, setReviewing] = useState(false)
  const [acknowledged, setAcknowledged] = useState(false)

  useEffect(() => {
    const check = createAppReleaseCheck(documentRelease(document))
    let mounted = true
    const inspect = async () => {
      if (document.visibilityState !== 'visible') return
      const result = await check.check()
      if (mounted) setRelease(result.status === 'changed' ? result.fingerprint : null)
    }
    inspect()
    window.addEventListener('focus', inspect)
    document.addEventListener('visibilitychange', inspect)
    return () => { mounted = false; check.stop(); window.removeEventListener('focus', inspect); document.removeEventListener('visibilitychange', inspect) }
  }, [])

  useEffect(() => { setReviewing(false); setAcknowledged(false) }, [release])
  if (!release || release === dismissed) return null

  return <aside className="app-update-notice" aria-label={t('App update')}>
    <p role="status"><strong>{t('An app update is available.')}</strong> {t('This tab keeps your current version and inputs until you choose to reload.')}</p>
    {reviewing ? <div className="app-update-review">
      <p>{t('Save or download open plans first. Reloading clears unsaved inputs and this search session. Updating the app does not verify car availability or prices.')}</p>
      <label><input type="checkbox" checked={acknowledged} onChange={e => setAcknowledged(e.target.checked)} />
        <span>{t('I have kept what I need and understand that unsaved inputs will be lost.')}</span></label>
      <div className="app-update-actions">
        <button type="button" disabled={!acknowledged} onClick={() => { if (acknowledged) window.location.reload() }}>{t('Reload this tab')}</button>
        <button type="button" onClick={() => { setReviewing(false); setAcknowledged(false) }}>{t('Keep working')}</button>
      </div>
    </div> : <div className="app-update-actions">
      <button type="button" onClick={() => setReviewing(true)}>{t('Review app update')}</button>
      <button type="button" onClick={() => setDismissed(release)}>{t('Not now')}</button>
    </div>}
  </aside>
}
